import {useEffect} from 'react';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import routes from './router/routes';
import {CircularProgress} from '@mui/material';
import {useLazyGetProfileDataQuery} from 'store/slices/profile';
import {useAppSelector} from 'store/store';

// Создаём роутер один раз на уровне модуля.
// Если вызывать createBrowserRouter внутри App, новый инстанс роутера
// создаётся на КАЖДЫЙ ре-рендер (а App ре-рендерится при смене isAuth/профиля,
// что и происходит при логине). Это приводит к полному перемонтированию дерева
// маршрутов поверх ещё доигрывающих анимаций MUI-порталов (Snackbar и т.п.) и
// падает ошибкой "removeChild ... is not a child of this node".
const router = createBrowserRouter(routes);

function App() {
  const isAuth = useAppSelector((state) => state.auth.isAuth);

  const [getProfileData, {data, isLoading}] = useLazyGetProfileDataQuery();

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      getProfileData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isAuth]);

  if (isLoading) {
    return (
      <CircularProgress
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          marginTop: '-12px',
          marginLeft: '-12px',
          fontSize: '50px',
        }}
      />
    );
  }

  return <RouterProvider router={router} />;
}

export default App;
